module.exports = __webpack_public_path__ + "static/media/nucleus-logo-2.65bcdfe2.svg";